import React, {useState} from "react";
import {useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import {PRIVATE_CHAT_LIST} from "utils";
import User from "../User";
import backIcon from "images/voiceChat/ic_back.svg";
import closeIcon from "images/voiceChat/ic_dismiss.svg";
import searchIcon from "images/voiceChat/ic_search.svg";
import styles from "./index.module.scss";
import {getUserList} from "api-v3";

function UserSearch({intl, prevPrivateTab, privateChatStatus, onClickPrivateTab, getMembers, getUserAttributes, sendCall}) {
  const [userList, setUserList] = useState([]);
  const userInfo = useSelector(state => state.userinfo);

  const onClickClose = () => {
    if (prevPrivateTab === PRIVATE_CHAT_LIST[3]) {
      onClickPrivateTab(PRIVATE_CHAT_LIST[0]);
    } else {
      onClickPrivateTab(prevPrivateTab);
    }
  };

  const getSearchUserList = async name => {
    const searchList = await getUserList({name: name});
    const worldList = await getMembers();
    const activeList = searchList.data.items?.filter(member => {
      const base64Id = new Buffer.from(member.ci).toString("base64");
      return userInfo.id !== member.ci && worldList.includes(base64Id) && member;
    });
    const resultList = activeList.map(member => {
      member.id = new Buffer.from(member.ci).toString("base64");
      return member;
    });
    setUserList(resultList);
  };

  return (
    <div className={styles.search_area}>
      <div className={styles.search_header}>
        <img onClick={onClickClose} src={backIcon} alt="back icon" />
        <img onClick={onClickClose} src={closeIcon} alt="close icon" />
      </div>
      <label htmlFor="voice_user_search" className={styles.search_wrap}>
        <img className={styles.search_icon} src={searchIcon} alt="" />
        <input
          type="text"
          placeholder={intl.formatMessage({id: "ID_VOICE_CHAT_SEARCH"})}
          onKeyDown={e => {
            if (e.key === "Enter") {
              getSearchUserList(e.target.value);
            }
          }}
          id="voice_user_search"
        />
      </label>
      {userList?.length === 0 && <p className={styles.placeholder}>{intl.formatMessage({id: "ID_VOICE_CHAT_SEARCH_PLACEHOLDER"})}</p>}
      <div className={styles.user_list}>
        {userList?.map((user, i) => (
          <User key={i} user={user} sendCall={sendCall} privateChatStatus={privateChatStatus} getUserAttributes={getUserAttributes} />
        ))}
      </div>
    </div>
  );
}

export default injectIntl(UserSearch);
